export default __webpack_public_path__ + "static/media/smallChalet.c1065a07.svg";